<!-- RENAME: Versandaufteilung (overlay is confusing since this class places the button) -->
<template lang="html">
    <div>
        <div class="d-flex align-items-center@medium justify-content-center@until-medium flex-column@until-medium mt-prj2">
            <a @click.prevent="showModal" class="btn btn--dark w-100@until-medium w-auto@large">{{'versandaufteilungVornehmen'|translate}}</a>
            <div class="pt-prj2@until-medium px-prj2@medium pt-0@medium text-small v-spacing-child-prj line-height-13">
                <VersandaufteilungIndicator :auflageLeft="distribute" :addClassesForTextColor="false" :addresses="addresses"/>

                <div v-if="addresses.length">
                    {{'versandaufteilungAdressen'|translate(addresses.length)}} ({{ price | toCurrency(globalConfig.shop.currency, globalConfig.locale)}})
                </div>
            </div>
        </div>

      <FlyerlineModal ref="modalRef" name="versandaufteilung" @close="handleClose" class="config-modal">
        <div class="bg-white">
          <h2 class="h3 mt-0 mb-0">{{'txtVersandaufteilungTitle'|translate}}</h2>
          {{'versandaufteilungOverlayText'|translate(formattedPrice)}}
          <div class="px-prj2 py-prj px-3@large border mt-prj3 flex flex-column gap-2">
            <table class="w-full table--bordered" :style="`grid-template-columns: repeat(${sortenData.length + 1}, 1fr);`">
              <thead>
              <tr>
                <th></th>
                <th v-for="[index, sorte] in sortenData.entries()">
                  <template v-if="sortenData.length === 1">
                    {{ "versandaufteilungAmountTitle" | translate }}
                  </template>
                  <template v-if="sortenData.length > 1">
                    {{ sorte.variantIdentifier }}
                  </template>
                  ({{ sorte.num ?? 0 }} {{ 'txtPieces'|translate }})
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="[addressIndex, address] in addresses.entries()">
                <td>
                  <VersandaufteilungAdresse
                      :address="address"
                      :addressService="addressService"
                      :canRemoveAddress="addressIndex !== 0"
                      :index="addressIndex"
                      :showAddressBook="user"
                  ></VersandaufteilungAdresse>
                  <div v-if="pristine === false && addressResults[addressIndex]?.okay === false" class="text-error text-small">
                    {{addressResults[addressIndex].message}}
                  </div>
                </td>
                <td v-for="[sortenIndex, sorte] in sortenData.entries()">
                  <input type="number" class="text-center" ref="sortenAmountRefs" :value="address.variants?.[sortenIndex]?.number ?? address.quantity" @input="updateAddressEntry(addressIndex)" />
                </td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <td>Total</td>
                <td v-for="[_, sorte] in sortenData.entries()">{{sorte.numAssigned ?? 0}} {{'txtPieces'|translate}}</td>
              </tr>
              <tr>
                <td>{{'txtVersandaufteilungRemainingPieces' | translate}}</td>
                <td v-for="[_, sorte] in sortenData.entries()">
                  <div :class="{'text-error': sorte.missing !== 0}">{{sorte.missing ?? 0}} {{'txtPieces'|translate}}</div>
                </td>
              </tr>
              </tfoot>
            </table>
            <div class="row mb-prj2">
              <div class="column">
                <a class="btn btn--dark btn--prj-min-x w-100@until-medium" @click="versandaufteilungService.addEmptyAddress()">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38.98 38.98" class="svg-icon mr-2"><circle cx="19.49" cy="19.49" r="18.49" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/><path d="M3.51-3.89v14.8m-7.4-7.4h14.8" transform="translate(15.98 15.98)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>
                  {{'versandaufteilungAddRecipient'|translate}}
                </a>
              </div>
            </div>
            <div class="row">
              <!--                    todo: separate modal? -> design -->
              <div class="column small-12">
                <div class="bg-shade-light p-prj2">
                  <div class="d-flex@medium align-items-center">
                    <input aria-hidden="true" type="file" id="addresses_fileupload"
                           class="sr-only"
                           accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                           required @change="uploadChanged($event)"/>
                    <label for="addresses_fileupload" class="btn btn--outline-dark w-100@until-medium bg-white label-aligned">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.91 12.76" class="mr-2 svg-icon"><path d="M.75,12.76a1,1,0,0,1-.51-.28.85.85,0,0,1-.24-.6V9a.85.85,0,0,1,.82-.88.79.79,0,0,1,.37.07A.85.85,0,0,1,1.73,9v1.82c0,.14,0,.14.13.14h8.2c.13,0,.13,0,.13-.13V9.09a.86.86,0,0,1,.36-.75.86.86,0,0,1,1.36.58v2.91a.9.9,0,0,1-.24.66.94.94,0,0,1-.43.25h-.08Z" transform="translate(0)" fill="#3a3a39" fill-rule="evenodd"/><path d="M6,9.26H5.87A.9.9,0,0,1,5.41,9a.93.93,0,0,1-.21-.69V2.91L5.12,3c-.31.31-.62.61-.93.93a1.05,1.05,0,0,1-.85.35.87.87,0,0,1-.69-.49.8.8,0,0,1,.13-.85l1-1L5.41.26a.86.86,0,0,1,1.24,0l1.07,1L9.13,2.71a1.19,1.19,0,0,1,.35.47.86.86,0,0,1-1.41.89c-.31-.3-.61-.61-.91-.91L6.94,3V8.37a.83.83,0,0,1-.38.73l-.37.16Z" transform="translate(0)" fill="#3a3a39" fill-rule="evenodd"/></svg>
                      {{'versandaufteilungUploadExcelFile'|translate}}
                    </label>
                    <p class="mb-0 pt-prj2 pt-0@medium px-prj2@medium p-prj2@large line-height-12">
                      {{ 'versandaufteilungUploadExceltxt1'|translate }}
                      <a role="button" @click="getExcelTemplate()"
                         :title="globalConfig.excel_url"
                         class="text-black font-weight-bold">{{ 'versandaufteilungUploadExceltxt2'|translate }}</a>
                      {{'versandaufteilungUploadExceltxt3'|translate}}
                    </p>
                  </div>
                  <div>
                    <div class="mt-prj2 pt-prj border-top border-shade-darker font-weight-bold" v-if="fileNames">
                      {{fileNames}}
                    </div>
                    <div id="addresses_fileupload_response" v-if="isError" class="mt-prj text-error d-flex line-height-12">
                      <svg xmlns="http://www.w3.org/2000/svg" class="mr-2 svg-icon flex-child-fix position-relative t-1px" viewBox="0 0 36 36"><circle cx="18" cy="18" r="18" fill="#e94d47"/><path d="M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z" fill="#fff"/></svg>
                      {{'txtErrorFileUpload'|translate}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="flex flex-row justify-content-between mt-2">
            <button @click="close()" class="btn btn--outline btn--outline-dark">{{'txtCancel' | translate}}</button>
            <button class="btn" @click="save()" :disabled="!pristine && !isValid">{{'txtApply' | translate}}</button>
          </div>
        </div>
        <TextAddress ref="textEditAddress"></TextAddress>
        <AddressBook ref="addressbookEditAddress"></AddressBook>
      </FlyerlineModal>

        <!--        todo: can we move these modals one layer up so they only exist once for the whole versandaufteilung? (aktuell werden alle modals des selben typs gleichzeitig geöffnet)-->
            <!--            todo: hand in current address -> prefill form fields -->
        <!--        Wenn die Auflage geändert hat, kann man gar nicht anders, als die Verteilung anzupassen. Alles andere macht keinen Sinn.
        Daher würde ich auf einen Zwischendialog verzichten
        -->
        <!--        <FlyerlineModal name="warnAuflageChanged" >-->
        <!--        </FlyerlineModal>-->
    </div>
</template>

<script>
import {doPost} from "classes/api.js";
import userStatus from "mixins/userStatus";

import FlyerlineModal from "fragments/FlyerlineModal";

import VersandaufteilungAdresse from "./VersandaufteilungAdresse"
import TextAddress from "./TextAddress";
import AddressBook from "./AddressBook";
import VersandaufteilungIndicator from "./VersandaufteilungIndicator";
import {VersandAufteilungService} from "../../services/versand-aufteilung.service";

export default {
        components: {VersandaufteilungIndicator, TextAddress, AddressBook, FlyerlineModal, VersandaufteilungAdresse},
        props: {
            isCheckout: Boolean,
            productImageUrl: String, // TODO directly from configurator or product
            productName: String, // TODO directly from configurator or product
        },
        inject: ['configuratorService', 'globalConfig'], // TODO globalConfig loswerden
        mixins: [userStatus],
        created() {
            this.addressService = {
                // Todo: select between address book and normal adresses
                updateTextAddress: (function(index) {
                    this.$refs.textEditAddress.open( this.addresses[index]?.deliveryaddress )
                    .then( data => this.updateAddress( index, data ))
                    .catch( data => console.error(data))
                }).bind(this),
                updateAddressBookAddress: (function(index) {
                    this.$refs.addressbookEditAddress.open( this.addresses[index] )
                        .then( data => this.updateAddress( index, data ))
                        .catch( data => console.error(data))
                }).bind(this),
            }
        },
        data() {
            return {
                sortenData: [],
                inputDebounce: undefined,
                isError: false,
                distribute: this.amount,
                fileNames: "",
                hasEmptyAddresses: false,
                versandaufteilungService: new VersandAufteilungService(this.configuratorService),
                addressResults: [],
                isValid: true,
                pristine: true,
                addressData: {
                  default: () => ({})
                }
            };
        },
        provide(){
            return {
                versandaufteilungService: this.versandaufteilungService
            }
        },
        methods: {
            updateAddressEntry(addressIndex) {
              clearTimeout(this.inputDebounce);
              this.inputDebounce = setTimeout(() => {

                Object.assign(this.addresses[addressIndex], {
                  variants: this.sortenData.length > 1 ? this.sortenData.map((sorte, sortenIndex) => {
                    return {
                      title: sorte.variantIdentifier,
                      number: this.$refs.sortenAmountRefs[addressIndex * this.sortenData.length + sortenIndex]?.valueAsNumber ?? 0
                    }
                  }) : [],
                  quantity: Array.from(Array(this.sortenData.length)).reduce((acc, _, i) => {
                    return acc + this.$refs.sortenAmountRefs[addressIndex * this.sortenData.length + i].valueAsNumber
                  }, 0)
                })

                const preparedBody = this.prepareBody(this.addresses, this.sortenData, this.numAuflagen);
                this.validate(preparedBody);
              }, 500)
            },
            validate(body) {
              return this.versandaufteilungService.validate(body).then((responseData) => {
                const variantResults = responseData['variantResults'];
                variantResults.forEach((variantResult) => {
                  // just one variant = noname variant aka no variants, always index 0
                  const sortenIndex = variantResults.length === 1 ? 0 : Math.max(this.sortenData.findIndex((sorte) => sorte.variantIdentifier === variantResult.title), -1);

                  if(sortenIndex > -1) {
                    const sorte = this.sortenData[sortenIndex];
                    sorte.missing = variantResult['numberMissing'];
                    sorte.numAssigned = variantResult['numberAssigned'];
                    // This will trigger a rerendering, since composites don't do deepchecks.
                    this.sortenData = structuredClone(this.sortenData);
                  }
                });
                this.addressResults = responseData['addressResults'];
                this.isValid = responseData.okay;
              })
            },
            prepareBody(addresses, sorten, numAuflagen) {
              const body = {
                data: {
                  print_run: numAuflagen,
                  num_specimen_copy: 0,
                  split_dispatch_rows: addresses.map((address) => {
                    const addressRows = {
                      address: {
                        company: address.deliveryaddress?.company ?? '',
                        department: address.deliveryaddress?.department ?? '',
                        salutation: address.deliveryaddress?.salutation ?? '',
                        first_name: address.deliveryaddress?.firstname ?? '',
                        last_name: address.deliveryaddress?.lastname ?? '',
                        address_line_1: address.deliveryaddress?.addressLine1 ?? '',
                        city: address.deliveryaddress?.city ?? '',
                        zip: address.deliveryaddress?.myZip ?? '',
                        country: this.globalConfig.contextid === 1 ? `${window?.dict_prj.get("txtSwitzerlandLichtenstein")}`: `${window?.dict_prj.get("txtGermany")}`
                      },
                      quantity: address.quantity
                    }

                    if(address.variants?.length > 1) {
                      addressRows['variants'] = address.variants.map((sorte) => {
                          return {
                            title: sorte.title,
                            number: sorte.number
                          }
                        });
                    } else {
                      addressRows['quantity_single_variant'] = address.quantity ?? 0
                    }

                    return addressRows;
                  })
                }
              }

              if(sorten.length > 1) {
                body.data['variants'] = sorten.map((sorte) => {
                  return {
                    title: sorte.variantIdentifier,
                    number: sorte.num
                  }
                })
              }

              return body;
            },
            save() {
              this.pristine = false;

              const preparedBody = this.prepareBody(this.addresses, this.sortenData, this.numAuflagen);

              this.validate(preparedBody).then(() => {
                if(this.isValid) {
                  const dataToPersist = this.formatPersistentData(this.addresses)

                  this.configuratorService.byConfigoptionType("Lieferart").dynamicValues = dataToPersist;

                  this.close();
                }
              })
            },
            formatPersistentData(addresses) {
              return ({
                versandaufteilung: addresses.map((address) => {
                  return {
                    quantity: address.quantity,
                    deliveryaddress: {
                      company: address.deliveryaddress?.company ?? '',
                      department: address.deliveryaddress?.department ?? '',
                      salutation: address.deliveryaddress?.salutation ?? '',
                      firstname: address.deliveryaddress?.firstname ?? '',
                      lastname: address.deliveryaddress?.lastname ?? '',
                      addressLine1: address.deliveryaddress?.addressLine1 ?? '',
                      city: address.deliveryaddress?.city ?? '',
                      myZip: address.deliveryaddress?.myZip ?? '',
                      country: this.globalConfig.contextid === 1 ? `${window?.dict_prj.get("txtSwitzerlandLichtenstein")}`: `${window?.dict_prj.get("txtGermany")}`
                    },
                    variants: address.variants.map((sorte) => {
                      return {
                        title: sorte.title,
                        number: sorte.number
                      }
                    })
                  }
                })
              })
            },
            close() {
              this.$refs.modalRef.close();
              this.configuratorService.validate();
            },
            showModal() {
              this.sortenData = this.configuratorService.byConfigoptionType("Sorten")?.dynamicValues.sortenFiles?.length > 1 ? structuredClone( this.configuratorService.byConfigoptionType("Sorten").dynamicValues.sortenFiles ) : [{
                title: `${window.dict_prj.get('txtVariant')} 1`,
                num: this.configuratorService.getPrintRunOrQuantity()
              }];
              this.$modal.show('versandaufteilung')
              const preparedBody = this.prepareBody(this.addresses, this.sortenData, this.numAuflagen);
              this.validate(preparedBody);
              this._oldAddresses = JSON.parse(JSON.stringify(this.addresses));
            },
            handleClose(){
                if (this.isVersandaufteilungComplete()) {
                    this.configuratorService.validate()
                    this.$emit('closed', [this.distribute, this._oldAddresses])
                } else {
                    this.restoreAddresses()
                }
            },
            isVersandaufteilungComplete () {
                return !this.isCheckout || (this.distribute == 0 && !this.hasEmptyAddresses)
            },
            checkEmptyAddresses() {
                this.hasEmptyAddresses = this.addresses.some( a => a.quantity == 0 || a.deliveryaddress == null )
            },
            restoreAddresses(){
                this.addresses.splice(0)
                this._oldAddresses.forEach( (value,idx) => this.$set(this.addresses, idx, value ) )
                this.$modal.hide('versandaufteilung')
            },
            uploadChanged(event) {
                // TODO: debounce
                this.isError = false
                if (typeof event.target.files[0] !== 'undefined') {
                    const formData = new FormData();
                    formData.append("file", event.target.files[0]);
                    this.fileNames = event.target.files[0].name
                    //fileLabel.innerHTML = '';

                    //fileLabel.innerHTML += event.target.files[0].name;
                    //fileLabel.classList.add("mt-prj2","pt-prj","border-top","border-shade-darker","font-weight-bold");

                    doPost("/api/prj/splittedshipping/addresses.de.json", formData).then(response => {
                        for (let address of response) {
                            this.addresses.push(address)
                        }
                        const preparedBody = this.prepareBody(this.addresses, this.sortenData, this.numAuflagen);
                        this.validate(preparedBody);
                    }).catch(xhr => this.isError = true)
                }
            },
            updateAddress(index, addressData) {
                const address = this.addresses[index];
                if (address) {
                    Object.assign(address, addressData)
                    this.$set(this.addresses, index, address)
                }
              const preparedBody = this.prepareBody(this.addresses, this.sortenData, this.numAuflagen);
              this.validate(preparedBody);
            },
            updateDistribution() {
                this.distribute = this.amount - this.addresses.reduce((a, v) => a + v.quantity, 0)
            },
          getExcelTemplate() {
              let body = {
                variants: this.sortenData.length > 1 ? this.sortenData.map((sorte)=>{return sorte.variantIdentifier}) : []
              };

            // https://stackoverflow.com/a/9834261
            fetch(`/api/prj/splitdispatch/addresses.${window.languagepath}.xlsx`, {
              method: "POST",
              body: JSON.stringify(body),
              headers: {
                "Content-type": "application/json; charset=UTF-8"
              }
            })
                .then(resp => resp.status === 200 ? resp.blob() : Promise.reject('something went wrong'))
                .then(blob => {
                  const url = window.URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.style.display = 'none';
                  a.href = url;
                  // the filename you want
                  a.download = 'mailing-distribution.xlsx';
                  document.body.appendChild(a);
                  a.click();
                  window.URL.revokeObjectURL(url);
                  // or you know, something with better UX...
                })
                .catch(() => console.error('Could not download excel template'));
          }
        },
        mounted() {
            this.addresses
            this.updateDistribution();
        },
        computed: {
            price: function () {
                return this.configuratorService.byConfigoptionType("Lieferart").customValues.lieferkostenTotal
            },
            formattedPrice: function(){
              return this.$options.filters.toCurrency(this.price ,this.globalConfig.shop.currency, this.globalConfig.locale);
            },
            amount: function () {
              return this.configuratorService.byConfigoptionType("Lieferart").customValues.versandaufteilungToDistributeAmount
            },
            addresses() {
                return this.versandaufteilungService.addresses() || []
            },
          numAuflagen () {
            return  this.configuratorService.getPrintRunOrQuantity();

          }
        },
        watch: {
            addresses: {
                handler(){
                    this.updateDistribution()
                    this.checkEmptyAddresses()
                },
                deep: true

            },
            amount: {
                handler(){
                    if( this.distribute == 0 ) {
                        this.showModal()
                    }
                    this.updateDistribution();
                }
            }
        }
    };
</script>

<style scoped>
.config-group .text-error {
  color: #fc4a40 !important;
  padding: 0;
  position: static;
  border: none !important;
}
</style>